import { render, staticRenderFns } from "./ContrastSchool.vue?vue&type=template&id=88292610&scoped=true"
import script from "./ContrastSchool.vue?vue&type=script&lang=js"
export * from "./ContrastSchool.vue?vue&type=script&lang=js"
import style0 from "./ContrastSchool.vue?vue&type=style&index=0&id=88292610&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88292610",
  null
  
)

export default component.exports